const sessionConstants = {
  GET_ALL_SESSION_REQUEST: 'GET_ALL_SESSION_REQUEST',
  GET_ALL_SESSION_SUCCESS: 'GET_ALL_SESSION_SUCCESS',
  GET_ALL_SESSION_FAILURE: 'GET_ALL_SESSION_FAILURE',

  GET_SESSION_REQUEST: 'GET_SESSION_REQUEST',
  GET_SESSION_SUCCESS: 'GET_SESSION_SUCCESS',
  GET_SESSION_FAILURE: 'GET_SESSSION_FAILURE',

  ADD_SESSION_REQUEST: 'ADD_SESSION_REQUEST',
  ADD_SESSION_SUCCESS: 'ADD_SESSION_SUCCESS',
  ADD_SESSION_FAILURE: 'ADD_SESSION_FAILURE',

  UPDATE_SESSION_REQUEST: 'UPDATE_SESSION_REQUEST',
  UPDATE_SESSION_SUCCESS: 'UPDATE_SESSION_SUCCESS',
  UPDATE_SESSION_FAILURE: 'UPDATE_SESSION_FAILURE',

  DELETE_SESSION_REQUEST: 'DELETE_SESSION_REQUEST',
  DELETE_SESSION_SUCCESS: 'DELETE_SESSION_SUCCESS',
  DELETE_SESSION_FAILURE: 'DELETE_SESSION_FAILURE',

  REMOVE_REGISTRANT_REQUEST: 'REMOVE_REGISTRANT_REQUEST',
  REMOVE_REGISTRANT_SUCCESS: 'REMOVE_REGISTRANT_SUCCESS',
  REMOVE_REGISTRANT_FAILURE: 'REMOVE_REGISTRANT_FAILURE',

  ADD_COMMENT_REQUEST: 'ADD_COMMENT_REQUET',
  ADD_COMMENT_SUCCESS: 'ADD_COMMENT_SUCCESS',
  ADD_COMMENT_FAILURE: 'ADD_COMMENT_FAILURE',

  GET_COMMENT_REQUEST: 'GET_COMMENT_REQUEST',
  GET_COMMENT_SUCCESS: 'GET_COMMENT_SUCCESS',
  GET_COMMENT_FAILURE: 'GET_COMMENT_FAILURE',

  DELETE_COMMENT_REQUEST: 'DELETE_COMMENT_REQUEST',
  DELETE_COMMENT_SUCCESS: 'DELETE_COMMENT_SUCCESS',
  DELETE_COMMENT_FAILURE: 'DELETE_COMMENT_FAILURE',

  CREATE_ZOOM_REQUEST: 'CREATE_ZOOM_REQUEST',
  CREATE_ZOOM_SUCCESS: 'CREATE_ZOOM_SUCCESS',
  CREATE_ZOOM_FAILURE: 'CREATE_ZOOM_FAILURE',

  DELETE_ZOOM_REQUEST: 'DELETE_ZOOM_REQUEST',
  DELETE_ZOOM_SUCCESS: 'DELETE_ZOOM_SUCCESS',
  DELETE_ZOOM_FAILURE: 'DELETE_ZOOM_FAILURE',
};

export default sessionConstants;
